import { render, staticRenderFns } from "./CompleteKyc.vue?vue&type=template&id=7b4f5799&scoped=true&"
import script from "./CompleteKyc.vue?vue&type=script&lang=js&"
export * from "./CompleteKyc.vue?vue&type=script&lang=js&"
import style0 from "./CompleteKyc.vue?vue&type=style&index=0&id=7b4f5799&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f5799",
  null
  
)

export default component.exports